import React from 'react'
import axios from 'axios'
import Uploader from './../components/uploader'
import TierSelect from './../components/tier_select'

const Item = ({item, remove, update, submit, handleImageUploadComplete}) => {
	return (
		<form className="row" data-id={item.id} onChange={ (e) => {update(e.target.closest('form'))} } onSubmit={submit}>
			<div className="col_4">
				{
					item.icon ?
						<img src={item.icon} alt={item.name} data-src={item.icon} /> :
						null
				}
				<Uploader
					className="thumb_drop"
					uploadComplete={ (imageURL) => handleImageUploadComplete(imageURL, item.id) }
					label="Drop an image (or click) to update logo"
				/>
			</div>
			<div className="col_8">
				<p>id: {item.id}</p>
				<input type="text" defaultValue={item.name ? decodeURIComponent(item.name) : ''} placeholder="Title" className="name" />
				<input type="text" defaultValue={item.url ? decodeURIComponent(item.url) : ''} placeholder="Link" className="url" />
				<TierSelect tiers={['Gold', 'Silver', 'Bronze']} selectedTier={item.tier != null ? item.tier : -1} />
				<button type="delete" onClick={ () => {remove(item.id)}}>Delete {decodeURIComponent(item.name)}</button>
			</div>
		</form>
	)
}

const List = ({items, remove, update, submit, handleImageUploadComplete}) => {
	return (
		<div className="items_container">
			{items && items.map( item => {
				return (<Item item={item} key={item.id} remove={remove} update={update} submit={submit} handleImageUploadComplete={handleImageUploadComplete} /> )
			})}
		</div>
	)
}

class Sponsors extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			items: [],
			readyToSave: false,
			changesSaved: false,
			message: ''
		}
	}

	componentDidMount(){
		this.fetchData(this.props.id)
	}

	fetchData(id){
		axios.get('https://dhsetheatre-api.madebypeppernet.com//api-admin.php', {
			params: {
				filename: 'sponsors'
			}
		}).then( response => {
			this.setState({
				items: response.data.items
			})
		})
	}

	handleAddNewItem(){
		// Render a new form.
		const items = this.state.items || []

		// Generate a new id.
		const id = items ? items.reduce( (id, item) => {
			if(item.id >= id){
				id = parseInt(item.id, 10) + 1
			}
			return id
		}, 0) : 0

		// Add the new item to the list.
		items.push({
			id: id,
			name: '',
			url: '',
			icon: null,
			tier: ''
		})

		// Save it to state.
		this.setState({ items })
	}

	handleImageUploadComplete(imageURL, id){
		// Need to store the imageURL to the form.
		var items = this.state.items.map( item => {
			if(item.id === id){
				item.icon = imageURL
			}
			return item
		})

		this.setState({
			items: items,
			readyToSave: true
		})
	}

	handleItemRemove(id){
		// Filter the list by the item selected to remove.
		// eslint-disable-next-line
		const items = this.state.items.filter( item => item.id != id )

		// Save the updated array to state.
		this.setState({
			items: items,
			readyToSave: true,
			message: ''
		})
	}

	handleItemUpdate(form){
		// Generate a new list updating the selected item.
		var items = this.state.items.map( item => {
			// eslint-disable-next-line
			if(item.id == form.getAttribute('data-id')){
				return {
					id: form.getAttribute('data-id'),
					name: encodeURIComponent(form.querySelector('.name').value),
					url: encodeURIComponent(form.querySelector('.url').value),
					icon: form.querySelector('img') ? form.querySelector('img').getAttribute('data-src') : '',
					tier: encodeURIComponent(form.querySelector('.tier').options[form.querySelector('.tier').selectedIndex].value)
				}
			} else {
				return item
			}
		})

		this.setState({
			items: items,
			readyToSave: true,
			message: ''
		})
	}

	handleSaveChanges(){
		// Create the data to store.
		var data = {
			items: this.state.items,
		}

		// Save the items to the API.
		axios({
			method: 'POST',
			url: 'https://dhsetheatre-api.madebypeppernet.com//api-admin.php',
			headers: { 'Content-type': 'application/x-www-form-urlencoded' },
			data: {
				filename: 'sponsors',
				content: JSON.stringify(data)
			}
		}).then( (response) => {
			this.setState({
				readyToSave: false,
				changedSaved: true,
				message: 'Preview Saved'
			})
		})
	}

	handleSubmit(e){
		// Kill default functionality.
		e.preventDefault()
		return false
	}

	render() {
		return (
			<section className="container edit">
				<h2>Sponsors</h2>
				{ this.state.readyToSave ?
						<button className="save button" onClick={this.handleSaveChanges.bind(this)}>Save Preview</button> :
						null
				}
				{
					this.state.message.length ?
						<p className="message">{this.state.message}</p> :
						null
				}
				<List
					items={this.state.items}
					remove={this.handleItemRemove.bind(this)}
					update={this.handleItemUpdate.bind(this)}
					submit={this.handleSubmit.bind(this)}
					handleImageUploadComplete={this.handleImageUploadComplete.bind(this)}
				/>
				<button className="add button" onClick={this.handleAddNewItem.bind(this)}>Add New Sponsor</button>
			</section>
		)
	}
}

export default Sponsors



// WEBPACK FOOTER //
// ./src/pages/sponsors.js